export default {
    'it-IT': {
        editCart: 'Modifica ordine',
        editCartLink: 'carrello/riepilogo-carrello',
        cartSummaryLinesTotal: 'Totale prodotti',
        cartSummaryCouponDiscount: 'Coupon',
        cartStep1ShippingTotal: 'Spese minime di consegna *',
        cartSummaryShippingTotal: 'Spese di spedizione',
        cartSummaryCollectionFeesTotal: 'Spese incasso',
        cartStep1GrandTotal: 'Totale ordine **',
        customFeesEstimateMessage: 'Stima IVA',
    },
    'fr-FR': {
        editCart: 'Modifier commande',
        editCartLink: 'panier/resume-ordre',
        cartSummaryLinesTotal: 'Total des produits',
        cartSummaryCouponDiscount: 'Bon',
        cartStep1ShippingTotal: 'Coûts de livraison minimum *',
        cartSummaryShippingTotal: "Frais d'envoi",
        cartSummaryCollectionFeesTotal: "Frais d'encaissement",
        cartStep1GrandTotal: 'Total de la commande **',
        customFeesEstimateMessage: 'Estimation TVA',
    },
    'es-ES': {
        editCart: 'Modificar pedido',
        editCartLink: 'cesta/resumen-pedido',
        cartSummaryLinesTotal: 'Total productos',
        cartSummaryCouponDiscount: 'Cupón',
        cartStep1ShippingTotal: 'Gastos mínimos de envío *',
        cartSummaryShippingTotal: 'Gastos de envío',
        cartSummaryCollectionFeesTotal: 'Gastos de gestión',
        cartStep1GrandTotal: 'Total pedido **',
        customFeesEstimateMessage: 'Estimación IVA',
    },
    'en-GB': {
        editCart: 'Edit order',
        editCartLink: 'cart/order-summary',
        cartSummaryLinesTotal: 'Items subtotal',
        cartSummaryCouponDiscount: 'Coupon',
        cartStep1ShippingTotal: 'Minimum shipping cost *',
        cartSummaryShippingTotal: 'Shipping cost',
        cartSummaryCollectionFeesTotal: 'Collection fees',
        cartStep1GrandTotal: 'Order total **',
        customFeesEstimateMessage: 'VAT estimate',
    },
    'en-US': {
        editCart: 'Edit order',
        editCartLink: 'cart/order-summary',
        cartSummaryLinesTotal: 'Items subtotal',
        cartSummaryCouponDiscount: 'Coupon',
        cartStep1ShippingTotal: 'Minimum shipping cost *',
        cartSummaryShippingTotal: 'Shipping cost',
        cartSummaryCollectionFeesTotal: 'Collection fees',
        cartStep1GrandTotal: 'Order total **',
        customFeesEstimateMessage: 'VAT estimate',
    },
    'de-DE': {
        editCart: 'Bestellung bearbeiten',
        editCartLink: 'warenkorb/bestellübersicht',
        cartSummaryLinesTotal: 'Produktsumme',
        cartSummaryCouponDiscount: 'Coupon',
        cartStep1ShippingTotal: '* Mindestversandkosten',
        cartSummaryShippingTotal: 'Versandkosten',
        cartSummaryCollectionFeesTotal: 'Einzugs- und Bankgebühren',
        cartStep1GrandTotal: '** Bestellsumme',
        customFeesEstimateMessage: 'Schätzung MwSt./USt.',
    },
    'en-AU': {
        editCart: 'Edit order',
        editCartLink: 'cart/order-summary',
        cartSummaryLinesTotal: 'Items subtotal',
        cartSummaryCouponDiscount: 'Coupon',
        cartStep1ShippingTotal: 'Minimum shipping cost *',
        cartSummaryShippingTotal: 'Shipping cost',
        cartSummaryCollectionFeesTotal: 'Collection fees',
        cartStep1GrandTotal: 'Order total **',
        customFeesEstimateMessage: 'GST estimate',
    },
};
